import { useMemo } from 'react';
import type RatingsBreakdown from '@alltrails/types/RatingsBreakdown';

export default function useRatingsBreakdown(ratingsBreakdown?: RatingsBreakdown): { totalReviewsCount: number; averageRating: string } {
  return useMemo(() => {
    if (!ratingsBreakdown) {
      return { totalReviewsCount: 0, averageRating: '0' };
    }

    let averages = 0;
    let count = 0;

    Object.keys(ratingsBreakdown).forEach(key => {
      count += ratingsBreakdown[key];
      averages += ratingsBreakdown[key] * Number(key);
    });

    const average = count === 0 ? 0 : averages / count;

    // Historically we format the average like "3.75", but could update and localize in the future if desired
    return { totalReviewsCount: count, averageRating: average.toLocaleString('en-US', { maximumFractionDigits: 2 }) };
  }, [ratingsBreakdown]);
}
